import cx from 'classnames'

type Props = {
  className?: string
}

export const Divider = ({className}: Props) => {
  return <div className={cx('bg-gray-300 w-full h-px', className)}></div>
}
